import React, { useEffect, useState } from "react";
import { DURATION_OPTIONS } from "../../constants";
import Dropdown from "../../../../dropdown";
import { round } from "lodash";
import "./style.scss";
import { Link } from "react-router-dom";
import { getRouting } from "../../../../../../../utils/common";


const SchemeCard = (props) => {
  const { fund, onAddToCartClick, toggle, durationValues, setDurationValues } =
    props;
  const [selectedDuration, setSelectedDuration] = useState("11");

  const onDropdownSelect = (value) => {
    console.log(value);
    Object.values(DURATION_OPTIONS).map((ele) => {
      console.log(ele, ele.name, value);
      if (ele.name === value) {
        setSelectedDuration(ele.value);
      }
    });
  };

  const onDurationChange = (value) => {
    console.log(value);

    // setDurationValues((currentValue) => ({
    //     ...currentValue,
    //     [fundCode]: '300',
    // }));
  };

  useEffect(() => {
    setDurationValues((currentValue) => ({
      ...currentValue,
      [fund.fundCode]: "11",
    }));
  }, [fund]);

  const getImageSrc = (riskProfile) => {
    var pathName = "null";
    var riskProfile = riskProfile.split(" ").join("").toLowerCase();

    if (riskProfile.includes("moderatelyhigh")) pathName = "moderately-high";
    else if (riskProfile.includes("veryhigh")) pathName = "very-high";
    else if (
      (riskProfile.includes("to") && riskProfile.includes("moderate")) ||
      riskProfile.includes("moderate")
    )
      pathName = "moderate";
    else if (riskProfile.includes("moderatelylow")) pathName = "moderately-low";
    else if (riskProfile.includes("high")) pathName = "high";
    else if (riskProfile.includes("low") && !riskProfile.includes("to"))
      pathName = "low";

    return pathName;
  };

  return (
    <div className="fund-container">
      <div className="about-fund">
        <h4 className="fund-title">{fund?.fundName}</h4>
        <ul className="filter-list">
          {fund.fundCategory?.length > 0 &&
            fund.fundCategory.map((ele) => {
              return <li className="moderatediv">{ele}</li>;
            })}
          {fund.riskReturnProfile?.length > 0 &&
            fund.riskReturnProfile.map((ele) => {
              return <li className="moderatediv"><img
                src={
                  `/images/HomePage/${getImageSrc(
                    ele
                  )}.svg`
                }
              /> <p>{ele}</p></li>;
            })}
          {/* <li>24k+ Invested Investors</li> */}
        </ul>
        <div className="fund-details">
          <div className="nav-details">
            <p>NAV as on {toggle
              ? fund?.fundNavRegular?.nav_date &&
              fund.fundNavRegular.nav_date[selectedDuration]
              : fund?.fundNavDirect?.nav_date &&
              fund.fundNavDirect.nav_date[selectedDuration]
            }
            </p>
            <div className="nav-value rupee-icon">
              {toggle
                ? fund?.fundNavRegular?.nav_amount &&
                round(
                  fund.fundNavRegular.nav_amount[selectedDuration],
                  2
                )
                : fund?.fundNavDirect?.nav_amount &&
                round(
                  fund.fundNavDirect.nav_amount[selectedDuration],
                  2
                )}
            </div>
          </div>
          {/* <div className="breakLine"></div>
          <div className="return-details">
            <div className="return-dropdown">
              <p>CAGR</p>
              <Dropdown dropdownOptions={Object.values(DURATION_OPTIONS)} defaultSelected={DURATION_OPTIONS[1].name} onChange={(value) => {onDropdownSelect(value,fund.fundCode)}}></Dropdown>
              <Dropdown
                dropdownOptions={Object.values(DURATION_OPTIONS)}
                defaultSelected={DURATION_OPTIONS[selectedDuration].name}
                onSelect={(value) => onDropdownSelect(value)}
                fromECartJourney={true}
              ></Dropdown>
            </div>
            <div className="return-value">
              {toggle
                ? fund?.fundNavRegular?.annualisedreturns &&
                round(
                  fund.fundNavRegular.annualisedreturns[selectedDuration],
                  2
                )
                : fund?.fundNavDirect?.annualisedreturns &&
                round(
                  fund.fundNavDirect.annualisedreturns[selectedDuration],
                  2
                )}
              %
            </div>
          </div> */}
        </div>
      </div>

      <div className="cta-buttons">
        {/* <button className="details-cta">
          Details
        </button> */}
        <Link
          to={getRouting(
            `/product-solutions/overview/${fund?.suggestedUrl}/${toggle ? 'regular' : 'direct'}`
          )}
        >
          <button className="details-cta">
            Details
          </button>
        </Link>
        <button
          className="addToCart-cta"
          onClick={() =>
            onAddToCartClick({
              ...fund,
              isDirect: toggle === false,
              isRegular: toggle === true,
            })
          }
        >
          Add to cart
        </button>
      </div>
    </div>
  );
};

export default SchemeCard;
